// extracted by css-extract-rspack-plugin
export default {"more":"TagPicker_more_OlERJ","brandTheme":"TagPicker_brandTheme_drI6W"};